export const NOT_RECORDED = 'Not recorded'

export function recordedTime(value: string | null | undefined): number | null {
  if (typeof value !== 'string' || !value.trim()) return null
  const time = new Date(value).getTime()
  return Number.isFinite(time) ? time : null
}

export function formatRecordedDate(
  value: string | null | undefined,
  options?: Intl.DateTimeFormatOptions
): string {
  const time = recordedTime(value)
  return time === null ? NOT_RECORDED : new Date(time).toLocaleString('en-IN', options)
}

export function recordedIso(value: string | null | undefined): string {
  const time = recordedTime(value)
  return time === null ? NOT_RECORDED : new Date(time).toISOString()
}

/** Unknown dates sort after recorded dates in both directions, without an epoch. */
export function compareRecordedDates(
  left: string | null | undefined,
  right: string | null | undefined,
  direction: 'asc' | 'desc' = 'asc'
): number {
  const a = recordedTime(left),
    b = recordedTime(right)
  if (a === null) return b === null ? 0 : 1
  if (b === null) return -1
  return (a - b) * (direction === 'asc' ? 1 : -1)
}

export function recordedBooleanLabel(
  value: boolean | null | undefined,
  whenTrue: string,
  whenFalse: string
): string {
  return value === true ? whenTrue : value === false ? whenFalse : NOT_RECORDED
}
